function formatNumber(number, fractionalDigits) {
    if (number === undefined || number == null) {
        return ""
    }
    return Number(number).toLocaleString('hu-HU', {minimumFractionDigits: 0, maximumFractionDigits: fractionalDigits})
}

export default formatNumber;
